var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 13.2305C3.3125 13.2305 3.04688 13.1211 2.82813 12.9023C2.60938 12.6836 2.5 12.418 2.5 12.1055V1.60547C2.5 1.29297 2.60938 1.02734 2.82813 0.808594C3.04688 0.589844 3.3125 0.480469 3.625 0.480469H11.875C12.1875 0.480469 12.4531 0.589844 12.6719 0.808594C12.8906 1.02734 13 1.29297 13 1.60547V12.1055C13 12.418 12.8906 12.6836 12.6719 12.9023C12.4531 13.1211 12.1875 13.2305 11.875 13.2305H3.625ZM1.375 15.4805C1.0625 15.4805 0.796875 15.3711 0.578125 15.1523C0.359375 14.9336 0.25 14.668 0.25 14.3555V3.61172C0.25 3.44922 0.303125 3.31484 0.409375 3.20859C0.515625 3.10234 0.65 3.04922 0.8125 3.04922C0.975 3.04922 1.10938 3.10234 1.21562 3.20859C1.32187 3.31484 1.375 3.44922 1.375 3.61172V14.3555H9.7C9.8625 14.3555 9.99688 14.4086 10.1031 14.5148C10.2094 14.6211 10.2625 14.7555 10.2625 14.918C10.2625 15.0805 10.2094 15.2148 10.1031 15.3211C9.99688 15.4273 9.8625 15.4805 9.7 15.4805H1.375Z",
    fill: "#ACB5C3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.8325aad56e55b55c1831a49077793605.svg";
export { ForwardRef as ReactComponent };